module.exports = __webpack_public_path__ + "img/shape_right_trapezoid.1b40edf6.svg";